var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "btn",
      class: {
        "btn-primary": _vm.value === _vm.tab,
        "btn-secondary": _vm.value !== _vm.tab
      },
      on: {
        click: function($event) {
          return _vm.$emit("input", _vm.tab)
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }